/** Canonical PAN sentinel values (UI + API + DB). */
export const PAN_SENTINEL_NOT_AVAILABLE = "PANNOTAVBL";
export const PAN_SENTINEL_APPLIED = "PANAPPLIED";

/**
 * Normalize legacy / alternate spellings to canonical tokens for forms and saves.
 * Real PANs are returned uppercase without spaces.
 */
export function canonicalizePanValue(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return "";
  const compact = s.replace(/\s+/g, "").toUpperCase();
  if (compact === "PANNOTAVBL") return PAN_SENTINEL_NOT_AVAILABLE;
  if (compact === "PANAPPLIED") return PAN_SENTINEL_APPLIED;
  if (["NA", "N/A", "NOTAVAILABLE"].includes(compact)) return PAN_SENTINEL_NOT_AVAILABLE;
  if (/^not\s*available$/i.test(s)) return PAN_SENTINEL_NOT_AVAILABLE;
  if (/^pan\s*applied$/i.test(s)) return PAN_SENTINEL_APPLIED;
  const panOnly = s.replace(/\s/g, "").toUpperCase();
  if (/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panOnly)) return panOnly;
  return s;
}

/** True when PAN should be ignored for uniqueness / duplicate checks (sentinels). */
export function isPanSentinelForUniqueness(value) {
  const c = canonicalizePanValue(value);
  return c === PAN_SENTINEL_NOT_AVAILABLE || c === PAN_SENTINEL_APPLIED;
}
